import { AccountLabel } from "@/entities/Labeling/Account.model";
import { useApiQuery } from "@/api/hooks/useApiQuery";
import { getLineageMetrics } from "@/entities/Finance/Finance.queries";
import { SourceFile } from "./SourceFile";
import { MetricCode } from "../Metrics";

export function MetricSourceFiles({
    code,
    onSourceSelect,
}: {
    code: MetricCode;
    onSourceSelect: () => void;
}) {
    const isFinanceLabel = Object.values(AccountLabel).includes(
        code as AccountLabel,
    );
    const lineagedMetric = useApiQuery(getLineageMetrics, {
        params: {
            labels: [code as AccountLabel],
        },
        enabled: isFinanceLabel,
    });

    if (!isFinanceLabel) return <p>this is not a finance label</p>;

    const sources = [
        ...new Set(
            lineagedMetric.data?.flatMap((lm) =>
                lm.lineagedValues?.flatMap((lv) =>
                    lv.accounts?.map((account) => account.dataAssetId),
                ),
            ),
        ),
    ].filter(Boolean) as string[];

    return (
        <div className="flex flex-col gap-3">
            {sources.map((source) => (
                <SourceFile
                    fileId={source}
                    key={source}
                    onSelect={onSourceSelect}
                />
            ))}
        </div>
    );
}
